import { colors } from '@ajaibid/components';
import { css } from '@emotion/css';

export const styWrapper = css`
  display: flex;
  overflow: hidden;
  flex-grow: 1;
`;

export const styNavigation = css`
  display: flex;
  border-left: 2px solid ${colors.NEUTRAL_3};
  justify-content: space-between;

  button {
    border: none;
    background: none;
    cursor: pointer;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;

    &:focus:not(:focus-visible) {
      outline: none;
    }

    :hover {
      background-color: ${colors.NEUTRAL_1};
    }
  }
`;

export const styShadowWrapper = ({ leftShadow, rightShadow }) => css`
  overflow: hidden;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: -10px;
    width: 10px;
    ${leftShadow ? 'box-shadow: 2px 0px 6px #DBDBDB' : ''};
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: -10px;
    width: 10px;
    ${rightShadow ? 'box-shadow: -2px 0px 6px #DBDBDB' : ''};
  }
`;

export const styStockTickerWrapper = css`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  border-left: 2px solid ${colors.NEUTRAL_3};
`;

export const styStockTicker = css`
  display: flex;
  height: 100%;
  width: fit-content;
`;

export const styStockTickerItem = ({ isActive }) => css`
  display: flex;
  gap: 11px;
  padding: 0 12px;
  align-items: center;
  justify-content: space-between;
  cursor: default;

  background-color: ${isActive ? colors.AJAIB_BLUE_1 : colors.NEUTRAL_0};
  border-top: none;
  border-left: none;
  border-bottom: none;
  border-right: 1px solid ${colors.NEUTRAL_2};
  color: #000000;

  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  min-width: 150px;
  box-sizing: border-box;

  &:hover,
  &:focus {
    ${isActive ? '' : `background-color: ${colors.NEUTRAL_1}`};
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  .___content {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: nowrap;
  }

  .___code {
    color: ${colors.AJAIB_BLUE_5};
  }

  .___close {
    padding: 0;
    margin: 0;
    cursor: pointer;
    opacity: 0.8;
    border: none;
    background: none;
    width: 16px;
    height: 16px;

    &:hover {
      opacity: 1;
    }
  }
`;
